import { NewsAuthorizationStatusEnum } from '../../../data/models/enum/news-authorization-status.enum';
import { ImageItem } from '../../../ui/components/select-simple-list/model/item-image.interface';

export const statusFilter = (hasAuthorization: boolean): ImageItem[] => {

    let result = [
        {
            id: NewsAuthorizationStatusEnum.AUTHORIZATION_PENDING,
            name: NewsAuthorizationStatusEnum.AUTHORIZATION_PENDING,
            imageUrl: '',
            isChecked: false,
        },
        {
            id: NewsAuthorizationStatusEnum.AUTHORIZED,
            name: NewsAuthorizationStatusEnum.AUTHORIZED,
            imageUrl: '',
            isChecked: false,
        },
        {
            id: NewsAuthorizationStatusEnum.NOT_AUTHORIZED,
            name: NewsAuthorizationStatusEnum.NOT_AUTHORIZED,
            imageUrl: '',
            isChecked: false,
        },
        {
            id: NewsAuthorizationStatusEnum.VISUALIZED,
            name: NewsAuthorizationStatusEnum.VISUALIZED,
            imageUrl: '',
            isChecked: false,
        },
        {
            id: NewsAuthorizationStatusEnum.NOT_VISUALIZED,
            name: NewsAuthorizationStatusEnum.NOT_VISUALIZED,
            imageUrl: '',
            isChecked: false,
        },
    ] as ImageItem[];


    if (!hasAuthorization) {
        result = removeItemById(result, NewsAuthorizationStatusEnum.AUTHORIZATION_PENDING)
        result = removeItemById(result, NewsAuthorizationStatusEnum.AUTHORIZED)
        result = removeItemById(result, NewsAuthorizationStatusEnum.NOT_AUTHORIZED)
    }

    return result
}

const removeItemById = (arr: ImageItem[], id: NewsAuthorizationStatusEnum) => {
    return arr.filter((obj) => obj.id !== id);
}